export default function useRoute(
  path: string,
  component: unknown,
  name: string,
  { ...rest } = {}
): any {
  return { path, component, name, ...rest }
}
